export default "__VITE_ASSET__3wPc4a$v__"